"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectPartition = void 0;
const objectPartition = (obj, keys) => keys.reduce(([included, excluded], key) => {
    const _a = excluded, _b = key, value = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    return typeof value !== 'undefined'
        ? [Object.assign(Object.assign({}, included), { [key]: value }), rest]
        : [included, excluded];
}, [{}, obj]);
exports.objectPartition = objectPartition;
//# sourceMappingURL=objectPartition.js.map